<!--  STATUS  -->

<div *ngIf="showStatus() && !quote.is_eligible_for_finance_manager" class="heading status lite-status" [class.locked]="locked">
	<i class="icon-tick" [ngClass]="isProcessed() || isSubmitted() ? 'pri-fg pri-bg' : 'pos-fg pos-bg'"></i>
	<h3>{{ getDisplayStatus() }}!</h3>
</div>

<!-- END STATUS  -->

<!--  ACTUAL STATUS  -->

<div *ngIf="showStatus() && quote.is_eligible_for_finance_manager" class="heading status actual-status" [class.locked]="locked">
	<div>
		<i [ngClass]="getActualStatus().icon"></i>
		<h3>{{ getActualStatus().friendly_name }}</h3>
	</div>
	<a class="button positive-button pointer-events-allowed" (click)="onManageFinanceApplication()">Manage Application</a>
</div>

<!-- END ACTUAL STATUS  -->

<!--  HEADING  -->

<div class="heading facility-type has-icon">
	<i *ngIf="show_info" class="icon-play text-hl pointer-events-allowed" (click)="showInfo($event)"></i>
	<h2>{{ quote.facility_type }} Representative Example</h2>
</div>

<!--  END HEADING  -->

<!--  MONTHLY COST  -->

<ul *ngIf="quote.number_of_regular_payments" class="key-value-list striped monthly-payments">
	<li class="highlighted">
		<div class="key">{{ quote.number_of_regular_payments | pluralise : 'regular payment' : '+s' }} of:</div>
		<div class="value sec-fg sec-bg">
			{{ formatQuoteValue(quote.regular_payment, 'money') }}
		</div>
	</li>
</ul>

<!--  END MONTHLY COST  -->

<!--  FULL BREAKDOWN  -->

<div class="breakdown" [class.horizontal]="breakdown_alignment === 'horizontal'">
	<ul class="key-value-list striped">
		<li>
			<div class="key">Cash Price</div>
			<div class="value">
				{{ formatQuoteValue(quote.total_cash_price, 'money') }}
			</div>
		</li>
		<li>
			<div class="key">Deposit</div>
			<div class="value" [class.highlight]="quote.deposit_altered" [ngClass]="{ 'text-hl': quote.deposit_altered }">
				{{ formatQuoteValue(quote.total_deposit - (vehicle.add_vat && [3, 8].includes(quote.finance_provider_id) === false ? grand_total_vat : 0), 'money') }}
			</div>
		</li>
		<li *ngIf="vehicle.add_vat && [3, 8].includes(quote.finance_provider_id) === false">
			<div class="key">Deposit (VAT Element)</div>
			<div class="value">
				{{ formatQuoteValue(grand_total_vat, 'money') }}
			</div>
		</li>
		<li>
			<div class="key">Total Amount of Credit</div>
			<div class="value">
				{{ formatQuoteValue(quote.advance, 'money') }}
			</div>
		</li>
		<li *ngIf="quote.charges !== null">
			<div class="key">Total Charge for Credit</div>
			<div class="value">
				{{ formatQuoteValue(quote.charges, 'money') }}
			</div>
		</li>
		<li>
			<div class="key">Acceptance Fee</div>
			<div class="value">
				{{ formatQuoteValue(quote.acceptance_fee, 'money') }}
			</div>
		</li>
		<li>
			<div class="key">Option to Purchase Fee</div>
			<div class="value">
				{{ formatQuoteValue(quote.option_to_purchase_fee, 'money') }}
			</div>
		</li>
		<li>
			<div class="key">
				Total Amount Payable
				<br class="visible-xxs visible-xs visible-sm" />
				<span *ngIf="vehicle.add_vat">(inc VAT)</span>
			</div>
			<div class="value">
				{{ formatQuoteValue(quote.total_payable, 'money') }}
			</div>
		</li>
		<li>
			<div class="key">Initial Payment</div>
			<div class="value">
				{{ formatQuoteValue(quote.first_payment, 'money') }}
			</div>
		</li>
	</ul>
	<ul class="key-value-list striped" [class.stripe-flipped]="!vehicle.add_vat && breakdown_alignment !== 'horizontal'">
		<li>
			<div class="key">
				{{ formatQuoteValue(quote.number_of_regular_payments, 'pluralise', ['Regular Payment', '+s']) }}
			</div>
			<div class="value">
				{{ formatQuoteValue(quote.regular_payment, 'money') }}
			</div>
		</li>
		<li>
			<div class="key">{{ quote.facility_type === 'PCP' ? 'Optional ' : '' }}Final Payment</div>
			<div class="value">
				{{ formatQuoteValue(quote.final_payment, 'money') }}
			</div>
		</li>
		<li>
			<div class="key">Agreement Length</div>
			<div class="value" [ngClass]="{ 'text-hl': quote.term_altered }">
				{{ formatQuoteValue(quote.term, null, null, ' months') }}
			</div>
		</li>
		<li>
			<div class="key">Representative APR</div>
			<div class="value">
				{{ formatQuoteValue(quote.apr, 'number', ['1.2-9'], '% APR') }}
			</div>
		</li>
		<li>
			<div class="key">Fixed Rate</div>
			<div class="value">
				{{ formatQuoteValue(quote.interest_rate, 'number', ['1.2-9'], '% PA') }}
			</div>
		</li>
		<li>
			<div class="key">Annual Mileage</div>
			<div class="value" [ngClass]="{ 'text-hl': quote.annual_mileage_altered }">
				<span *ngIf="quote.facility_type === 'PCP'">
					{{ formatQuoteValue(quote.annual_mileage, 'separated') }}
				</span>
				<span *ngIf="quote.facility_type === 'HP'">N/A</span>
			</div>
		</li>
		<li>
			<div class="key">Excess Mileage Charge</div>
			<div class="value">
				<span *ngIf="quote.facility_type === 'PCP'">
					{{ formatQuoteValue(quote.excess_mileage_charge, null, null, ' ppm') }}
				</span>
				<span *ngIf="quote.facility_type === 'HP'">N/A</span>
			</div>
		</li>
	</ul>
</div>

<!--  END FULL BREAKDOWN  -->

<!--  DISCLAIMER  -->

<div *ngIf="show_disclaimer && quote.altered" class="info-container">
	<p>
		* Quote value differs from your preference. Part exchange, finance settlement and non-financeable add-on products can affect the
		deposit.
	</p>
	<p *ngIf="show_vat_disclaimer">* VAT on commercial vehicles is included in the total deposit .</p>
</div>

<!--  END DISCLAIMER  -->
